<template>
  <div>
    <nav class="navbar navbar-expand-lg">
      <router-link
        class="navbar-brand"
        to="/"
        style="margin-left: 18px; display: flex; align-items: center"
      >
        <img
          alt="casafile Immobilien"
          id="logoImage"
          style="padding-bottom: 5px"
          src="../../assets/logo.png"
        />
      </router-link>

      <!-- Mobile toggler -->
      <div class="float-right">
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon">
            <i class="fas fa-bars toggler"></i>
          </span>
        </button>
      </div>

      <div
        class="collapse navbar-collapse flex-md-column"
        id="navbarNavDropdown"
      >
        <ul class="navbar-nav ml-auto">
          <!-- Ferienwohnungen -->
          <Dropdown :title="$t('base.header.menus.houses.title')">
            <DropdownItem @click="searchAll">{{
              $t("base.header.menus.houses.children.all")
            }}</DropdownItem>
            <InnerDropdown
              :title="$t('base.header.menus.houses.children.regions')"
            >
              <DropdownItem
                @click="goToRegion(region)"
                v-for="region in regions"
                :key="region.id"
                >{{ region.localizedName[$i18n.locale] }}</DropdownItem
              >
            </InnerDropdown>
            <InnerDropdown
              :title="$t('base.header.menus.houses.children.houseTypes')"
            >
              <DropdownItem
                :to="prepareSearchParams([], [houseType])"
                v-for="houseType in houseTypes"
                :key="houseType.id"
                >{{ houseType.localizedName | localized }}</DropdownItem
              >
            </InnerDropdown>
          </Dropdown>

          <!-- Beliebt im Ticino -->
          <Dropdown :title="$t('base.header.menus.ticino.title')">
            <DropdownItem
              :to="prepareSearchParams(['childrenAllowed', 'ch'], [])"
              >{{
                $t("base.header.menus.ticino.children.family")
              }}</DropdownItem
            >
            <DropdownItem
              v-if="houseTypes"
              :to="
                prepareSearchParams(
                  ['ch'],
                  [houseTypes.find((el) => el.localizedName.de === 'Rustico')]
                )
              "
              >{{
                $t("base.header.menus.ticino.children.rustici")
              }}</DropdownItem
            >
            <DropdownItem
              :to="prepareSearchParams(['dogsAllowed', 'ch'], [])"
              >{{ $t("base.header.menus.ticino.children.dog") }}</DropdownItem
            >
            <DropdownItem
              :to="prepareSearchParams(['swimmingPool', 'ch'], [])"
              >{{ $t("base.header.menus.ticino.children.pool") }}</DropdownItem
            >
          </Dropdown>

          <!-- Immobilien tessin -->
          <Dropdown :title="$t('base.header.menus.immobilienTessin.title')">
            <DropdownItem
              :closeOnClick="false"
              href="https://www.immobilien-tessin.ch/"
              >{{
                $t("base.header.menus.immobilienTessin.offersInTicino")
              }}</DropdownItem
            >
            <DropdownItem
              :closeOnClick="false"
              href="https://www.immobilien-tessin.ch/?type=mieten"
              >{{
                $t("base.header.menus.immobilienTessin.longTermOffers")
              }}</DropdownItem
            >
          </Dropdown>

          <!-- Object Inserieren -->
          <Dropdown :title="$t('base.header.menus.object.title')">
            <DropdownItem
              :href="$t('base.header.menus.object.children.insert.url')"
              :closeOnClick="false"
              >{{
                $t("base.header.menus.object.children.insert.title")
              }}</DropdownItem
            >
          </Dropdown>

          <!-- Kontakt -->
          <Dropdown :title="$t('base.header.menus.contact.title')">
            <DropdownItem
              :href="$t('base.header.menus.contact.children.press.url')"
              :closeOnClick="false"
              >{{
                $t("base.header.menus.contact.children.press.title")
              }}</DropdownItem
            >
            <DropdownItem
              :href="$t('base.header.menus.contact.children.team.url')"
              :closeOnClick="false"
              >{{
                $t("base.header.menus.contact.children.team.title")
              }}</DropdownItem
            >
            <DropdownItem
              :href="$t('base.header.menus.contact.children.contact.url')"
              :closeOnClick="false"
              >{{
                $t("base.header.menus.contact.children.contact.title")
              }}</DropdownItem
            >
          </Dropdown>

          <!-- Kundenlogin -->
          <NavItem :href="adminUrl"
            ><span style="width: 100%"
              >{{ $t("base.header.menus.login.title") }}
              <i class="fas fa-external-link-alt"></i></span
          ></NavItem>

          <HeaderLanguageSelector></HeaderLanguageSelector>
        </ul>
      </div>
    </nav>
    <!-- <SEOBanner style="position: relative"></SEOBanner> -->
  </div>
</template>

<script>
import Dropdown from "./components/Dropdown";
import HeaderLanguageSelector from "./components/HeaderLanguageSelector";
import InnerDropdown from "./components/InnerDropdown";
import NavItem from "./components/NavItem";
import DropdownItem from "./components/DropdownItem";
import SEOBanner from "@/base/SEOBanner";
import LanguageSelector from "@/components/common/LanguageSelector";
export default {
  /* RESOURCES
        https://www.codeply.com/go/ji5ijk6yJ4
        https://www.codeply.com/go/qTC6pAxWKv
        https://www.codeply.com/go/1Iz3DxS60l
        https://www.codeply.com/go/awyU7VTIJf
    */

  name: "Header",
  components: {
    Dropdown,
    HeaderLanguageSelector,
    InnerDropdown,
    DropdownItem,
    NavItem,
    SEOBanner,
    LanguageSelector,
  },
  computed: {
    regions: function () {
      let currentLocale = this.$i18n.locale;
      let regions = this.$store.getters.getRegions;

      return regions === undefined
        ? []
        : regions.sort((a, b) => (a.sequence < b.sequence ? -1 : 1));
    },
    houseTypes: function () {
      let currentLocale = this.$i18n.locale;
      let houseTypes = this.$store.getters.getHouseTypes;

      return houseTypes === undefined
        ? []
        : houseTypes.sort((a, b) =>
            a.localizedName[currentLocale].localeCompare(
              b.localizedName[currentLocale]
            )
          );
    },
    query: function () {
      return this.$store.getters.getQuery;
    },
  },
  methods: {
    goToRegion: function (region) {
      // We first reset all other params
      this.$store.commit("setBaseQuery");

      // Then navigate to the region
      this.$router.push(region.url);
    },
    searchAll: function () {
      // Set the base query
      this.$store.commit("setBaseQuery");

      // Navigate to the view
      this.$router.push("/search");
    },
    prepareSearchParams: function (props, houseTypes) {
      let propsArray = props.map((el) => `${el}=true`);
      //
      let houseTypesArray = houseTypes
        .map((houseType) => {
          let locale = this.$i18n.locale;

          let isDefined =
            !this.isUndefined(houseType) &&
            !this.isUndefined(houseType.localizedName);

          return isDefined
            ? `houseType=${encodeURIComponent(houseType.localizedName[locale])}`
            : undefined;
        })
        .filter((el) => el !== undefined);

      return `/search?${propsArray.concat(houseTypesArray).join("&")}`;
    },
  },
  data() {
    return {
      adminUrl: process.env.VUE_APP_ADMIN_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  padding: 0;
  border-bottom: 5px solid $primary-color !important;
  background-color: white !important;
  margin-bottom: 0px;
}

@media (max-width: 991.98px) {
  .navbar {
    // Otherwise, fix it to the top
    position: sticky !important;
    top: 0;
  }
}

.navbar-toggler {
  background-color: $primary-color !important;
  padding: 5px;
}

.toggler {
  height: 100%;
  width: 100%;
  line-height: 30px;
  text-align: center;
}

.navbar-brand {
  padding: 0;
  margin: 0;
}

#logoImage {
  padding: 0;
  width: 220px;
  height: auto;
}

@media (max-width: 575.98px) {
  #logoImage {
    width: 180;
    height: auto;
  }
}

@media (min-width: 992px) {
  .navbar {
    min-height: $navbar-height;
  }

  .navbar-brand {
    height: $navbar-height;
    line-height: $navbar-height;
  }

  #navbarNavDropdown,
  .navbar-nav {
    height: $navbar-height;
  }
}

@media (max-width: 767.98px) {
  #logoImage {
    width: 150px;
  }
}
</style>
